export const inviteUserTypes = [
  { label: "Internal(LDAP) User", value: "internalUser" },
  { label: "External User", value: "externalUser" },
];
